module.exports = __webpack_public_path__ + "static/media/julesAvatarSm.04f47a53.png";